import { createContext, useContext, useState, useEffect } from "react";
import { useAuth } from "./AuthContext";
import client from "../api/client";

const SettingsContext = createContext();

export function SettingsProvider({ children }) {
  const { user } = useAuth();
  
  const [settings, setSettings] = useState({
    show_celestial: true,
    show_mind_body: true,
    show_prompt: true,
    preserve_chat_history: false,
    mushroom_enabled: false,
    session_flow_enabled: false,
  });
  console.log('Full settings object:', settings);
console.log('Mushroom enabled value:', settings?.mushroom_enabled);
console.log('Session flow enabled value:', settings?.session_flow_enabled);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setLoading(false);
      return;
    }
    client.get("/settings")
      .then(res => {
        setSettings(res.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [user]);

  const updateSettings = async (updated) => {
    const merged = { ...settings, ...updated };
    setSettings(merged);
    try {
      await client.put("/settings", merged);
    } catch (err) {
      console.error("Failed to save settings:", err);
    }
  };
console.log('settings.mushroom_enabled');
console.log(settings.mushroom_enabled);
  return (
    <SettingsContext.Provider value={{ settings, updateSettings, loading }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  return useContext(SettingsContext);
}
